document.addEventListener("DOMContentLoaded", () => {

  const specs = window.thicknessSpecs || {};

  let selectedThickness = null;
  let selectedFeel = null;

  const thicknessBtns = document.querySelectorAll(".thickness-btn");
  const feelBtns      = document.querySelectorAll(".feel-btn");
  const configMain    = document.getElementById("config-main");
  const configSub     = document.getElementById("config-sub");
  const cards         = document.querySelectorAll(".nc-card");
  const feelDesc      = document.getElementById("feelDescription");

  /* -------------------------
     UPDATE UI
  ------------------------- */
  function updateUI() {

    const data = specs[selectedThickness];

    /* Config Card */
    if (configMain) {
      configMain.innerText =
        [selectedThickness, selectedFeel]
          .filter(Boolean)
          .join(" · ");
    }

    if (configSub && data) {
      configSub.innerText =
        (data.spinal_support || '') +
        ' · ' +
        (data.cooling || '');
    }

    /* Right Cards */
    if (data) {
      cards.forEach(card => {

        const valueEl = card.querySelector(".nc-value");
        if (!valueEl) return;

        const key = valueEl.dataset.key;

        valueEl.innerText = data[key] || '--';

      });
    }
  }

  /* -------------------------
     THICKNESS BUTTONS
  ------------------------- */
  thicknessBtns.forEach(btn => {

    btn.addEventListener("click", () => {

      thicknessBtns.forEach(b =>
        b.classList.remove("active")
      );

      btn.classList.add("active");

      selectedThickness =
        btn.dataset.thickness;

      updateUI();

    });

  });

  /* -------------------------
     FEEL BUTTONS
     (Metafield Based)
  ------------------------- */
  feelBtns.forEach(btn => {

    btn.addEventListener("click", () => {

      feelBtns.forEach(b =>
        b.classList.remove("active")
      );

      btn.classList.add("active");

      selectedFeel =
        btn.dataset.title;

      if (feelDesc) {
        feelDesc.textContent =
          btn.dataset.description;
      }

      updateUI();

    });

  });

  /* -------------------------
     DEFAULT THICKNESS
  ------------------------- */
  const defaultThickness =
    document.querySelector(".thickness-btn.active")
    || thicknessBtns[0];

  if (defaultThickness) {

    thicknessBtns.forEach(b =>
      b.classList.remove("active")
    );

    defaultThickness.classList.add("active");

    selectedThickness =
      defaultThickness.dataset.thickness;

  }

  /* -------------------------
     DEFAULT FEEL
     (Uses active class from Liquid)
  ------------------------- */
  const defaultFeel =
    document.querySelector(".feel-btn.active")
    || feelBtns[0];

  if (defaultFeel) {

    feelBtns.forEach(b =>
      b.classList.remove("active")
    );

    defaultFeel.classList.add("active");

    selectedFeel =
      defaultFeel.dataset.title;

    if (feelDesc) {
      feelDesc.textContent =
        defaultFeel.dataset.description;
    }

  }

  /* -------------------------
     INITIAL LOAD
  ------------------------- */
  updateUI();

});